import { render, staticRenderFns } from "./daikoujilu.vue?vue&type=template&id=d8154cd8&scoped=true"
import script from "./daikoujilu.vue?vue&type=script&lang=js"
export * from "./daikoujilu.vue?vue&type=script&lang=js"
import style0 from "./daikoujilu.vue?vue&type=style&index=0&id=d8154cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8154cd8",
  null
  
)

export default component.exports